import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../createApiConfig';

export const WhitelistApi = createApi({
  reducerPath: 'WhitelistApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Whitelist'],
  endpoints: (builder) => ({
    listWhiteList: builder.query({
      query: (params) => ({
        url: `/whitelist-channels/`,
        params,
      }),
      providesTags: ['Whitelist'],
    }),

    listWhiteListHistory: builder.query({
      query: ({ id, params }) => ({
        url: `/whitelist-channels/${id}/history/`,
        params,
      }),
      
      providesTags: ['Whitelist'],
    }),

    createWhitelist: builder.mutation({
      query: (data) => ({
        url: `/whitelist-channels/?expand=user,last_updated_by,customers`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Whitelist'],
    }),

    updateWhitelist: builder.mutation({
      query: ({ id, data }) => ({
        url: `/whitelist-channels/${id}/?expand=user,last_updated_by,customers`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Whitelist'],
    }),

    createWhitelistChannelsCustomers: builder.mutation({
      query: (data) => ({
        url: `/whitelist-channels/channels-customers/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Whitelist'],
    }),
  }),
});

export const {
  useListWhiteListQuery,
  useLazyListWhiteListQuery,
  useListWhiteListHistoryQuery,
  useCreateWhitelistMutation,
  useUpdateWhitelistMutation,
  useCreateWhitelistChannelsCustomersMutation,
} = WhitelistApi;
